
define('text!templates/modules/profile/edit/custom-message-edit-content.html',[],function () { return '<div class="panel-body" id="custom-message-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="custom-message-edit-form"></div>\n</div>\n';});

